import { Link, Text } from "basis";

export const ExceptionContent = () => (
  <Text testId="something-went-wrong">
    We've encountered an unexpected problem.
    <br />
    {`Please `}
    <Link href="/contact" newTab={false}>
      contact Latitude
    </Link>
    {` to update your details.`}
  </Text>
);
